import type {ListLeadsSearchInput} from "./list-leads.schema";

import {listLeads} from "@project/sdk/sales";
import {ListLeadsResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {leadKeys} from "../../../lead-keys";

import {listLeadsSearchSchema} from "./list-leads.schema";

export function listLeadsQueryOptions(rawInput: ListLeadsSearchInput) {
  const params = listLeadsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: leadKeys.list(params),
    queryFn: async ({signal}) => ListLeadsResponse.parse(await listLeads(params, {signal})),
  });
}
